import { render } from "./VORLAGE.vue?vue&type=template&id=893d49cc"
import script from "./VORLAGE.vue?vue&type=script&lang=js"
export * from "./VORLAGE.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__